module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bhJYu"))).then(() => module.bundle.root('iDabs'));